const ACTIVE_META_TAGS = ['description', 'canonical'];
const BLAZE_X_FRAME_OPTIONS_DEFAULT = 'SAMEORIGIN';
const META_TAGS_LOOKUP = {
  description: {
    apiKey: 'metaDescription',
    htmlTagName: 'meta',
    tagKeyName: 'name',
    contentDataKeyName: 'content'
  },
  canonical: {
    apiKey: 'canonicalUrl',
    htmlTagName: 'link',
    tagKeyName: 'rel',
    contentDataKeyName: 'href'
  }
};
const PB_TYPE_IMAGE = 'image';
const PB_TYPE_TEXTBLOCK = 'textblock';
const PB_TYPE_CAROUSEL = 'carousel';
const SEARCH_FILTER = 'searchfilter';
const COLON = ':';
const DOUBLE_SLASH = '//';
const HTTPS = 'https://';
const DEFAULT_ROUTE_REGEX = /^\/[a-z0-9€_\/]+(?:[-\/\.]{1,2}[a-z0-9\/€_\/]+)*$|^\/$/i;
const ROUTE_REGEX = process.env.BLAZE_ROUTE_REGEX ? new RegExp(process.env.BLAZE_ROUTE_REGEX) : DEFAULT_ROUTE_REGEX;
const PREVIEW_REGEX = /^(\/_preview)/;
const PREVIEW_MODE = 'Preview Mode';
const GTM_STRING = 'gtm';
const DEBUG_LOGO = {
  SRC: 'https://images.thisisblaze.com/logo-small-27-40.png',
  ALT: 'blaze-logo'
};
const PUBLISHED_ = 'published_';
const RESPONSE_404 = '404 Not Found\n';
const SITEMAP_STORE_KEY = 'default_sitemap';
const ROUTE_PATTERN_SITEMAP = process.env.BLAZE_ROUTE_PATTERN_SITEMAP || '/sitemap.xml';
const sitemapFilePrefix = process.env.BLAZE_CONTENT_SITEMAP_URL_PREFIX || 'sitemap';
const ROUTE_PATTERN_SITEMAP_FILE_REGEX = new RegExp(`/${sitemapFilePrefix}/.*\.xml`);
const ROUTE_PATTERN_ROBOTS_TXT = '/robots.txt';
const BLAZE_STATIC_ROUTE_STORE_KEY = 'default';
const STATIC_FILE_FORWARD_HEADERS = ['content-length', 'last-modified', 'etag'];
const APPLE_TAGS = [{
  href: '/static/icons/touch-icon-iphone.png',
  rel: 'apple-touch-icon'
}, {
  href: '/static/icons/touch-icon-ipad.png',
  rel: 'apple-touch-icon',
  sizes: '152x152'
}, {
  href: '/static/icons/touch-icon-iphone-retina.png',
  rel: 'apple-touch-icon',
  sizes: '180x180'
}, {
  href: '/static/icons/touch-icon-ipad-retina.png',
  rel: 'apple-touch-icon',
  sizes: '167x167'
}];
const NOT_FOUND_STATUS_CODE = 404;
const ROOT_SELECTOR_CLASS_PREFIX = 'root-selector';
const ROOT_SELECTOR_SEPARATOR = '--';
const RESOLVER_CONTAINER_CLASS = 'resolver-container';
module.exports = {
  APPLE_TAGS,
  ACTIVE_META_TAGS,
  COLON,
  DOUBLE_SLASH,
  GTM_STRING,
  HTTPS,
  META_TAGS_LOOKUP,
  SEARCH_FILTER,
  PB_TYPE_IMAGE,
  PB_TYPE_TEXTBLOCK,
  PB_TYPE_CAROUSEL,
  PREVIEW_MODE,
  ROUTE_REGEX,
  PREVIEW_REGEX,
  DEBUG_LOGO,
  PUBLISHED_,
  RESPONSE_404,
  NOT_FOUND_STATUS_CODE,
  SITEMAP_STORE_KEY,
  ROUTE_PATTERN_SITEMAP,
  ROUTE_PATTERN_SITEMAP_FILE_REGEX,
  ROUTE_PATTERN_ROBOTS_TXT,
  BLAZE_STATIC_ROUTE_STORE_KEY,
  STATIC_FILE_FORWARD_HEADERS,
  ROOT_SELECTOR_CLASS_PREFIX,
  ROOT_SELECTOR_SEPARATOR,
  RESOLVER_CONTAINER_CLASS,
  BLAZE_X_FRAME_OPTIONS_DEFAULT
};
//# sourceMappingURL=constants.js.map